import {classifyProductStatus} from './productStatus';
import { Product, ProductCalculations, ProductWithCalculations, GlobalSettings, StatusType, StatusConfig } from '../types/inventory';

export function calculateMetrics(
  product: Product,
  settings: GlobalSettings
): ProductCalculations {
  const calculationPeriodDays = settings.calculationPeriodDays ?? product.diasPeriodo;
  const cmd = calculationPeriodDays > 0 ? product.vendasPeriodo / calculationPeriodDays : 0;
  const ddlt = cmd * settings.leadTime;
  const ss = cmd * settings.leadTime;
  const rop = ddlt;
  const cobertura = cmd > 0 ? product.estoqueAtual / cmd : 0;
  const estoqueAlvo = cmd * (settings.leadTime + settings.diasCoberturaAlvo);
  const pedidoSugerido = Math.max(0, estoqueAlvo - product.estoqueAtual);

  return {
    cmd,
    ddlt,
    ss,
    rop,
    cobertura,
    estoqueAlvo,
    pedidoSugerido
  };
}

export function getProductStatus(
  product: Product,
  calculations: ProductCalculations,
  settings: GlobalSettings
): StatusType {
  return classifyProductStatus({
    stock: product.estoqueAtual,
    flagNoSales: product.vendasPeriodo === 0 ? 1 : 0,
    safetyStock: calculations.ss,
    reorderPoint: calculations.rop,
    currentCoverage: calculations.cobertura,
    leadTime: settings.leadTime,
    targetCoverage: settings.diasCoberturaAlvo,
  });
}

export const statusConfigs: Record<StatusType, StatusConfig> = {
  ruptura: {
    label: 'Ruptura instalada',
    color: 'text-red-900',
    bgColor: 'bg-red-100'
  },
  sem_venda: {
    label: 'Sem venda (avaliar)',
    color: 'text-slate-900',
    bgColor: 'bg-slate-100'
  },
  iminente: {
    label: 'Ruptura iminente',
    color: 'text-orange-900',
    bgColor: 'bg-orange-100'
  },
  minimo: {
    label: 'Perto do mínimo',
    color: 'text-yellow-900',
    bgColor: 'bg-yellow-100'
  },
  critica: {
    label: 'Cobertura crítica',
    color: 'text-purple-900',
    bgColor: 'bg-purple-100'
  },
  excesso: {
    label: 'Excesso',
    color: 'text-blue-900',
    bgColor: 'bg-blue-100'
  },
  saudavel: {
    label: 'Saudável',
    color: 'text-green-900',
    bgColor: 'bg-green-100'
  }
};

export function enrichProductWithCalculations(
  product: Product,
  settings: GlobalSettings
): ProductWithCalculations {
  const calculations = calculateMetrics(product, settings);
  const status = getProductStatus(product, calculations, settings);
  const statusLabel = statusConfigs[status].label;

  return {
    ...product,
    ...calculations,
    status,
    statusLabel
  };
}
